import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';
import moment from 'moment';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import * as actions from '../actions';
import * as c from '../constant';

const ImportCsvContainer = ({
  getList,
  list,
  isLoading,
  pager,
  getReportAccess,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [formData, setFormData] = useState({
    subject: '',
  });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const getRoles = getJson('roles') || '';
  const pmtAdmin = getRoles === 'pmt_admin';

  const handleSelect = (index) => {
    if (index === 1) {
      setFormData({
        subject: 'ACTIVITY',
      });
      getList({ subject: 'ACTIVITY' });
      setSelectedIndex(1);
    }
    if (index === 0) {
      setFormData({
        subject: 'BUSINESS',
      });
      getList({ subject: 'BUSINESS' });
      setSelectedIndex(0);
    }
    if (index === 2) {
      setFormData({
        subject: 'APPLICATION',
      });
      getList({ subject: 'APPLICATION' });
      setSelectedIndex(2);
    }
    if (index === 3) {
      setFormData({
        subject: 'FEE',
      });
      getList({ subject: 'FEE' });
      setSelectedIndex(3);
    }
    if (index === 4) {
      setFormData({
        subject: 'NATURE',
      });
      getList({ subject: 'NATURE' });
      setSelectedIndex(4);
    }
    if (index === 5) {
      setFormData({
        subject: 'LINE',
      });
      getList({ subject: 'LINE' });
      setSelectedIndex(4);
    }
  };

  const handleRefresh = (index) => {
    if (index === 1) {
      setFormData({
        subject: 'ACTIVITY',
      });
      getList({ subject: 'ACTIVITY' });
      setSelectedIndex(1);
    }
    if (index === 0) {
      setFormData({
        subject: 'BUSINESS',
      });
      getList({ subject: 'BUSINESS' });
      setSelectedIndex(0);
    }
    if (index === 2) {
      setFormData({
        subject: 'APPLICATION',
      });
      getList({ subject: 'APPLICATION' });
      setSelectedIndex(2);
    }
    if (index === 3) {
      setFormData({
        subject: 'FEE',
      });
      getList({ subject: 'FEE' });
      setSelectedIndex(3);
    }
    if (index === 4) {
      setFormData({
        subject: 'NATURE',
      });
      getList({ subject: 'NATURE' });
      setSelectedIndex(3);
    }
    if (index === 5) {
      setFormData({
        subject: 'LINE',
      });
      getList({ subject: 'LINE' });
      setSelectedIndex(3);
    }
  };

  const [token, setToken] = useState('');

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const handleChangePage = (page) => {
    getList({ ...formData, page });
  };

  useEffect(() => {
    getList({ subject: 'BUSINESS' });

    setFormData({
      subject: 'BUSINESS',
    });
  }, []);

  const postFormData = (url) => (formdata, onProgress) =>
    new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;
        // eslint-disable-next-line no-unused-vars
        xhr.addEventListener('timeout', (e) =>
          resolve({
            status: 400,
            message: 'Request Timeout, Please try again.',
          })
        );
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.onload = () => {
          try {
            const jsonResponse = JSON.parse(xhr.response);
            const response = {
              status: xhr.status, // jsonResponse.status,
              data: jsonResponse,
            };
            resolve(response);
          } catch (err) {
            reject(err);
          }
        };
        xhr.onerror = () => {
          const errRes = {
            data: false,
            message: 'Oops..Something went wrong.',
          };
          Alert.error(errRes);
          return resolve(errRes);
        };
        if (xhr.upload) {
          xhr.upload.onprogress = (evt) => {
            if (evt.lengthComputable) {
              const progress = Math.ceil((evt.loaded / evt.total) * 100);
              if (onProgress) {
                onProgress(progress);
              }
            }
          };
        }
        xhr.send(formdata);
      } catch (err) {
        reject(err);
      }
    });

  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();

    try {
      data.append('file', file);
      data.append('subject', _.get(formData, 'subject'));
      const res = await postFormData(
        `${process.env.REACT_APP_WS}/api/v1/bpls/administrator/csv_imports`
      )(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        if (selectedIndex === 1) {
          getList({ subject: 'ACTIVITY' });
        }
        if (selectedIndex === 0) {
          getList({ subject: 'BUSINESS' });
        }
        if (selectedIndex === 2) {
          getList({ subject: 'APPLICATION' });
        }
        if (selectedIndex === 3) {
          getList({ subject: 'FEE' });
        }
        if (selectedIndex === 4) {
          getList({ subject: 'NATURE' });
        }
        if (selectedIndex === 4) {
          getList({ subject: 'LINE' });
        }
      }
      if (_.get(res, 'status') === 422) {
        let message = '';

        if (_.get(res, 'data.errors.subject.0')) {
          message = _.get(res, 'data.errors.subject.0');
        }

        if (_.get(res, 'data.errors.file.0')) {
          message = _.get(res, 'data.errors.file.0');
        }

        Alert.error(message);
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  const authProfile = getJson('profile') || {};
  const isSuperAdmin = _.get(authProfile, 'id') === '1';

  const handleDownload = (id) => (e) => {
    e.preventDefault();

    const reportAccessArgs = {
      path: `/api/v1/bpls/administrator/report/csv_imports/${id}/download_failed`,
      query: {
        email: _.get(authProfile, 'email'),
        output: 'D',
      },
    };
    getReportAccess(reportAccessArgs, (response) => {
      const src = `${response?.res?.res?.url || ''}`;
      window.location.href = src;
    });
  };

  useEffect(() => {
    const getToken = get('token') || '';
    setToken(getToken);
  }, []);

  return (
    <div className="mt-2">
      {/* <b className="mt-1 header-title mb-2">
        Import Business and Business Activity
      </b> */}
      <Tabs onSelect={handleSelect}>
        <TabList>
          <Tab>Business</Tab>
          <Tab>Business Activity</Tab>
          <Tab>Application</Tab>
          <Tab>Fees</Tab>
          {(isSuperAdmin || pmtAdmin) && (
            <>
              <Tab>Nature</Tab>
              <Tab>Line</Tab>
            </>
          )}
        </TabList>
        <TabPanel>
          <div className="d-flex mt-2 px-2">
            <div className="ml-auto row-nav">
              <div className="float-left">
                <div className="form-group">
                  {isLoading && (
                    <button
                      disabled
                      type="button"
                      className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                    >
                      <i className="fa fa-spin fa-spinner" />
                    </button>
                  )}
                </div>
              </div>
              <div className="float-right">
                <div className="form-group">
                  {!isLoading && (
                    <input
                      type="file"
                      className="btn btn-link input-upload"
                      onChange={fileHandler}
                    />
                  )}
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={onUploadFile}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Upload
                  </button>
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={() => handleRefresh(0)}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              {isLoading ? (
                <div
                  className="loading d-flex text-center justify-content-center align-items-center"
                  style={{ height: '500px' }}
                >
                  <div className="spinner text-center ">
                    <span className="fas fa-5x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th>SUBJECT</th>
                      <th>DATE UPLOADED</th>
                      <th>FILE NAME</th>
                      <th>FAILED ROWS</th>
                      <th>SUCCESS ROWS</th>
                      <th>TOTAL ROWS</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {list.map((item) => {
                      return (
                        <tr key={_.get(item, 'id')}>
                          <td>{_.get(item, 'attributes.subject') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.date_human')
                              ? moment(
                                  `${_.get(item, 'attributes.date_human')}`
                                ).format('MMM DD, YYYY')
                              : '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.file_name') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.success_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.total_rows') || '---'}
                          </td>
                          <td>{_.get(item, 'attributes.status') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') > 0 ? (
                              <a
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
                                href="#/"
                                onClick={handleDownload(item.id)}
                              >
                                <i className="fas fa-print" />
                              </a>
                            ) : (
                              'Completed'
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div className="list-pagination">
                {pager.total_pages > 1 ? (
                  <div className="d-flex justify-content-center text-center align-item-center">
                    <Pagination data={pager} onChange={handleChangePage} />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="d-flex mt-2 px-2">
            <div className="ml-auto row-nav">
              <div className="float-left">
                <div className="form-group">
                  {isLoading && (
                    <button
                      disabled
                      type="button"
                      className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                    >
                      <i className="fa fa-spin fa-spinner" />
                    </button>
                  )}
                </div>
              </div>
              <div className="float-right">
                <div className="form-group">
                  {!isLoading && (
                    <input
                      type="file"
                      className="btn btn-link input-upload"
                      onChange={fileHandler}
                    />
                  )}
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={onUploadFile}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Upload
                  </button>
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={() => handleRefresh(1)}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              {isLoading ? (
                <div
                  className="loading d-flex text-center justify-content-center align-items-center"
                  style={{ height: '500px' }}
                >
                  <div className="spinner text-center ">
                    <span className="fas fa-5x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th>SUBJECT</th>
                      <th>DATE UPLOADED</th>
                      <th>FILE NAME</th>
                      <th>FAILED ROWS</th>
                      <th>SUCCESS ROWS</th>
                      <th>TOTAL ROWS</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {list.map((item) => {
                      return (
                        <tr key={_.get(item, 'id')}>
                          <td>{_.get(item, 'attributes.subject') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.date_human')
                              ? moment(
                                  `${_.get(item, 'attributes.date_human')}`
                                ).format('MMM DD, YYYY')
                              : '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.file_name') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.success_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.total_rows') || '---'}
                          </td>
                          <td>{_.get(item, 'attributes.status') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') > 0 ? (
                              <a
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
                                href="#/"
                                onClick={handleDownload(item.id)}
                              >
                                <i className="fas fa-print" />
                              </a>
                            ) : (
                              'Completed'
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div className="list-pagination">
                {pager.total_pages > 1 ? (
                  <div className="d-flex justify-content-center text-center align-item-center">
                    <Pagination data={pager} onChange={handleChangePage} />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="d-flex mt-2 px-2">
            <div className="ml-auto row-nav">
              <div className="float-left">
                <div className="form-group">
                  {isLoading && (
                    <button
                      disabled
                      type="button"
                      className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                    >
                      <i className="fa fa-spin fa-spinner" />
                    </button>
                  )}
                </div>
              </div>
              <div className="float-right">
                <div className="form-group">
                  {!isLoading && (
                    <input
                      type="file"
                      className="btn btn-link input-upload"
                      onChange={fileHandler}
                    />
                  )}
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={onUploadFile}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Upload
                  </button>
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={() => handleRefresh(2)}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              {isLoading ? (
                <div
                  className="loading d-flex text-center justify-content-center align-items-center"
                  style={{ height: '500px' }}
                >
                  <div className="spinner text-center ">
                    <span className="fas fa-5x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th>SUBJECT</th>
                      <th>DATE UPLOADED</th>
                      <th>FILE NAME</th>
                      <th>FAILED ROWS</th>
                      <th>SUCCESS ROWS</th>
                      <th>TOTAL ROWS</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {list.map((item) => {
                      return (
                        <tr key={_.get(item, 'id')}>
                          <td>{_.get(item, 'attributes.subject') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.date_human')
                              ? moment(
                                  `${_.get(item, 'attributes.date_human')}`
                                ).format('MMM DD, YYYY')
                              : '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.file_name') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.success_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.total_rows') || '---'}
                          </td>
                          <td>{_.get(item, 'attributes.status') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') > 0 ? (
                              <a
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
                                href="#/"
                                onClick={handleDownload(item.id)}
                              >
                                <i className="fas fa-print" />
                              </a>
                            ) : (
                              'Completed'
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div className="list-pagination">
                {pager.total_pages > 1 ? (
                  <div className="d-flex justify-content-center text-center align-item-center">
                    <Pagination data={pager} onChange={handleChangePage} />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="d-flex mt-2 px-2">
            <div className="ml-auto row-nav">
              <div className="float-left">
                <div className="form-group">
                  {isLoading && (
                    <button
                      disabled
                      type="button"
                      className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                    >
                      <i className="fa fa-spin fa-spinner" />
                    </button>
                  )}
                </div>
              </div>
              <div className="float-right">
                <div className="form-group">
                  {!isLoading && (
                    <input
                      type="file"
                      className="btn btn-link input-upload"
                      onChange={fileHandler}
                    />
                  )}
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={onUploadFile}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Upload
                  </button>
                </div>
              </div>
              <div className="flow-right">
                <div className="form-group">
                  <button
                    type="button"
                    onClick={() => handleRefresh(3)}
                    className="ml-2 btn btn-link button-upload"
                  >
                    Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              {isLoading ? (
                <div
                  className="loading d-flex text-center justify-content-center align-items-center"
                  style={{ height: '500px' }}
                >
                  <div className="spinner text-center ">
                    <span className="fas fa-5x fa-spin fa-spinner" />
                  </div>
                </div>
              ) : (
                <table className="table table-striped table-sm table-bordered table-hover">
                  <thead className="table-header">
                    <tr>
                      <th>SUBJECT</th>
                      <th>DATE UPLOADED</th>
                      <th>FILE NAME</th>
                      <th>FAILED ROWS</th>
                      <th>SUCCESS ROWS</th>
                      <th>TOTAL ROWS</th>
                      <th>STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {list.map((item) => {
                      return (
                        <tr key={_.get(item, 'id')}>
                          <td>{_.get(item, 'attributes.subject') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.date_human')
                              ? moment(
                                  `${_.get(item, 'attributes.date_human')}`
                                ).format('MMM DD, YYYY')
                              : '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.file_name') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.success_rows') || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.total_rows') || '---'}
                          </td>
                          <td>{_.get(item, 'attributes.status') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.failed_rows') > 0 ? (
                              <a
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
                                href="#/"
                                onClick={handleDownload(item.id)}
                              >
                                <i className="fas fa-print" />
                              </a>
                            ) : (
                              'Completed'
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <div className="list-pagination">
                {pager.total_pages > 1 ? (
                  <div className="d-flex justify-content-center text-center align-item-center">
                    <Pagination data={pager} onChange={handleChangePage} />
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </TabPanel>
        {(isSuperAdmin || pmtAdmin) && (
          <>
            <TabPanel>
              <div className="d-flex mt-2 px-2">
                <div className="ml-auto row-nav">
                  <div className="float-left">
                    <div className="form-group">
                      {isLoading && (
                        <button
                          disabled
                          type="button"
                          className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                        >
                          <i className="fa fa-spin fa-spinner" />
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="float-right">
                    <div className="form-group">
                      {!isLoading && (
                        <input
                          type="file"
                          className="btn btn-link input-upload"
                          onChange={fileHandler}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flow-right">
                    <div className="form-group">
                      <button
                        type="button"
                        onClick={onUploadFile}
                        className="ml-2 btn btn-link button-upload"
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                  <div className="flow-right">
                    <div className="form-group">
                      <button
                        type="button"
                        onClick={() => handleRefresh(4)}
                        className="ml-2 btn btn-link button-upload"
                      >
                        Refresh
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  {isLoading ? (
                    <div
                      className="loading d-flex text-center justify-content-center align-items-center"
                      style={{ height: '500px' }}
                    >
                      <div className="spinner text-center ">
                        <span className="fas fa-5x fa-spin fa-spinner" />
                      </div>
                    </div>
                  ) : (
                    <table className="table table-striped table-sm table-bordered table-hover">
                      <thead className="table-header">
                        <tr>
                          <th>SUBJECT</th>
                          <th>DATE UPLOADED</th>
                          <th>FILE NAME</th>
                          <th>FAILED ROWS</th>
                          <th>SUCCESS ROWS</th>
                          <th>TOTAL ROWS</th>
                          <th>STATUS</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {list.map((item) => {
                          return (
                            <tr key={_.get(item, 'id')}>
                              <td>
                                {_.get(item, 'attributes.subject') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.date_human')
                                  ? moment(
                                      `${_.get(item, 'attributes.date_human')}`
                                    ).format('MMM DD, YYYY')
                                  : '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.file_name') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.failed_rows') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.success_rows') ||
                                  '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.total_rows') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.status') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.failed_rows') > 0 ? (
                                  <a
                                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
                                    href="#/"
                                    onClick={handleDownload(item.id)}
                                  >
                                    <i className="fas fa-print" />
                                  </a>
                                ) : (
                                  'Completed'
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                  <div className="list-pagination">
                    {pager.total_pages > 1 ? (
                      <div className="d-flex justify-content-center text-center align-item-center">
                        <Pagination data={pager} onChange={handleChangePage} />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="d-flex mt-2 px-2">
                <div className="ml-auto row-nav">
                  <div className="float-left">
                    <div className="form-group">
                      {isLoading && (
                        <button
                          disabled
                          type="button"
                          className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
                        >
                          <i className="fa fa-spin fa-spinner" />
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="float-right">
                    <div className="form-group">
                      {!isLoading && (
                        <input
                          type="file"
                          className="btn btn-link input-upload"
                          onChange={fileHandler}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flow-right">
                    <div className="form-group">
                      <button
                        type="button"
                        onClick={onUploadFile}
                        className="ml-2 btn btn-link button-upload"
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                  <div className="flow-right">
                    <div className="form-group">
                      <button
                        type="button"
                        onClick={() => handleRefresh(5)}
                        className="ml-2 btn btn-link button-upload"
                      >
                        Refresh
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  {isLoading ? (
                    <div
                      className="loading d-flex text-center justify-content-center align-items-center"
                      style={{ height: '500px' }}
                    >
                      <div className="spinner text-center ">
                        <span className="fas fa-5x fa-spin fa-spinner" />
                      </div>
                    </div>
                  ) : (
                    <table className="table table-striped table-sm table-bordered table-hover">
                      <thead className="table-header">
                        <tr>
                          <th>SUBJECT</th>
                          <th>DATE UPLOADED</th>
                          <th>FILE NAME</th>
                          <th>FAILED ROWS</th>
                          <th>SUCCESS ROWS</th>
                          <th>TOTAL ROWS</th>
                          <th>STATUS</th>
                          <th>ACTION</th>
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {list.map((item) => {
                          return (
                            <tr key={_.get(item, 'id')}>
                              <td>
                                {_.get(item, 'attributes.subject') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.date_human')
                                  ? moment(
                                      `${_.get(item, 'attributes.date_human')}`
                                    ).format('MMM DD, YYYY')
                                  : '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.file_name') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.failed_rows') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.success_rows') ||
                                  '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.total_rows') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.status') || '---'}
                              </td>
                              <td>
                                {_.get(item, 'attributes.failed_rows') > 0 ? (
                                  <a
                                    className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-2 cms-bg-color-primary"
                                    href="#/"
                                    onClick={handleDownload(item.id)}
                                  >
                                    <i className="fas fa-print" />
                                  </a>
                                ) : (
                                  'Completed'
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                  <div className="list-pagination">
                    {pager.total_pages > 1 ? (
                      <div className="d-flex justify-content-center text-center align-item-center">
                        <Pagination data={pager} onChange={handleChangePage} />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </TabPanel>
          </>
        )}
      </Tabs>
    </div>
  );
};

ImportCsvContainer.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ImportCsvContainer);
